"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var withStyles_1 = require("@material-ui/styles/withStyles");
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("./styles");
/**
 * Render a single link, highlight as current if currentPath and link path match
 */
var SiteHeaderLink = /** @class */ (function (_super) {
    __extends(SiteHeaderLink, _super);
    function SiteHeaderLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteHeaderLink.prototype.render = function () {
        var _a = this.props, linkPath = _a.linkPath, currentPath = _a.currentPath, children = _a.children, _b = _a.matchPrefix, matchPrefix = _b === void 0 ? false : _b, classes = _a.classes, isIndex = _a.isIndex;
        var currentPathWithTrailingSlash = currentPath.charAt(currentPath.length - 1) === '/' ?
            currentPath :
            currentPath + "/";
        var pathMatches = matchPrefix ?
            currentPathWithTrailingSlash.indexOf(linkPath) === 0 :
            currentPathWithTrailingSlash === linkPath;
        var indexMatch = isIndex === true && currentPath === '/';
        var maybeHighlightClasses = indexMatch || pathMatches ?
            { navLinkContainer: classes.currentNavLinkContainer, navLinkText: classes.currentNavLinkText } :
            { navLinkContainer: classes.navLinkContainer, navLinkText: classes.navLinkText };
        return (React.createElement(Grid_1.default, { item: true, className: maybeHighlightClasses.navLinkContainer },
            React.createElement(react_router_dom_1.Link, { to: linkPath, className: maybeHighlightClasses.navLinkText }, children)));
    };
    return SiteHeaderLink;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(SiteHeaderLink);
